<template>
  <span v-if="text" v-tooltip="tooltipValue" class="help-icon icon is-small">
    <i class="fa-solid fa-circle-question fa-xs" />
  </span>
</template>

<script>
import { computed } from 'vue'

export default {
  name: 'HelpIcon',
  props: {
    label: { type: String, default: null },
    text: { type: String, default: null },
  },
  setup(props) {
    const tooltipValue = computed(() => {
      if (!props.text) return undefined
      if (!props.label) return props.text
      return {
        content:
          `<div class="tooltip-label">${props.label}</div>` +
          `<div class="tooltip-desc">${props.text}</div>`,
        html: true,
      }
    })

    return { tooltipValue }
  },
}
</script>

<style lang="scss" scoped>
.help-icon {
  color: var(--neutral-lighter);
  cursor: help;
  flex-shrink: 0;
}
</style>
